<div *ngIf="ships">
  <div class="card card-nc" *ngIf="hasEntitlement('SEARCH_MERCHANT')">
    <div class="card-heading">
      <span class="search-header"> Merchant Profiles </span>
    </div>
    <div class="card-body">
      <form
        #searchForm="ngForm"
        [formGroup]="merchantSearchForm"
        name="merchantSearchForm"
        novalidate
      >
        <div class="row">
          <div class="col-md-12">
            <div class="row">
              <div class="form-group col-md-5">
                <app-dropdown-select-control
                  classes="form-control input-sm searhBoxheight"
                  elementId="location"
                  placeholder="Please select location."
                  [searchTerm]="selectedLocation"
                  [source]="ships"
                  (valueSelected)="selectLocation($event)"
                ></app-dropdown-select-control>
              </div>
              <div class="form-group col-md-6">
                <input
                  formControlName="searchTerm"
                  name="searchTerm"
                  id="searchTerm"
                  class="form-control input-sm searhBoxheight"
                  placeholder="Search merchant Name/Number/Type,cardNumber,stripAccount,chipAccount."
                />
                <span
                  class="help-block has-error validationMessage"
                  *ngIf="
                    !merchantSearchForm.get('searchTerm').valid &&
                    merchantSearchForm.get('searchTerm').touched &&
                    merchantSearchForm.get('searchTerm').errors
                  "
                >
                  Please enter at least 2 characters
                </span>
              </div>
              <div class="col-md-1">
                <button
                  type="submit"
                  [disabled]="!merchantSearchForm.valid"
                  (click)="submit()"
                  class="form-group btn btn-nc pull-right"
                  id="searchButton"
                >
                  SEARCH<i
                    [ngClass]="{ 'fa fa-spinner fa-spin': processing }"
                  ></i>
                </button>
                <br />
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div *ngIf="hasEntitlement('SEARCH_MERCHANT')" [ngSwitch]="whichView">
    <div *ngSwitchCase="'none'" class="row justify-content-center">
      <div *ngIf="processing" class="col-1">
        <i class="fa fa-spinner fa-spin fa-4x"></i>
      </div>
    </div>
    <div *ngSwitchCase="'noResults'">
      <div class="searchResults">
        <div class="row searchResultsRow">No results found.</div>
      </div>
    </div>
    <div *ngSwitchCase="'inputErr'">
      <div class="searchResults">
        <div class="row searchResultsRow">
          Please enter at least 1 search parameter.
        </div>
      </div>
    </div>
    <div *ngIf="pagedResults && pagedResults.length > 0" class="searchResults">
      <app-merchant-search-results
        *ngSwitchCase="'results'"
        [results]="pagedResults"
      ></app-merchant-search-results>
      <div style="margin: 10px;">
        <app-pagination
          *ngIf="results && results.length > 25"
          (pageSet)="pageSet($event)"
          [totalItems]="results.length"
          itemsPerPage="25"
        ></app-pagination>
      </div>
    </div>
  </div>

  <div
    class="text-error"
    style="color:RED"
    *ngIf="!hasEntitlement('SEARCH_MERCHANT')"
  >
    You do not have permission to view this page
  </div>
</div>
